import React, { useState } from "react";

const HeaderContainer = ({ Owl, HeaderBuilder }) => {
    [Owl.data, Owl.set] = useState({});
    return <HeaderBuilder data={Owl.data} set={Owl.set} />;
};

export default HeaderContainer;
